import React, { useState } from "react";

const FilterButtonComponent = ({
  handleClearFilter,
  handleOpenModal,
  // handleCheck,
  handleApplyFilter,
  userEmail
}) => {
  // const [employee, setEmployee] = useState({});
  // const userEmail = result?.employeeData?.email;
  //  console.log("USER EMAIL:", employee?.email);
  const allowedEmails = [
    "raushan@fship.in",
    "mukund@fship.in",
    "raju@fship.in",
  ];
  const isAllowed = allowedEmails.includes(userEmail?.toLowerCase());

  return (
    <div
      style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
    >

      <button
        style={{ marginLeft: "12px" }}
        onClick={handleApplyFilter}
        className="btn btn-outline-success"
      >
        Apply Filter
      </button>



      <button
        style={{ marginLeft: "12px" }}
        onClick={handleClearFilter}
        className="btn btn-outline-secondary"
      >
        Clear Filter
      </button>


      {isAllowed && (
        <button
          style={{ marginLeft: "12px" }}
          onClick={handleOpenModal}
          className="btn btn-outline-info"
        >
          Export
        </button>
      )}
    </div>
  );
};

export default FilterButtonComponent;
